const getStateName = state => {
    let name = ''
    if (stateNames[state]) name = stateNames[state]
    return name
}

const stateNames = {
    accept: 'dołączono',
    request: 'oczekuje na aktywację'
}

const initialState = {
    loading: false,
    stores: null,
    ableToJoinStores: null,
    ableToDisconnectStores: null,
    ableToActivationCancelStores: null,
    allSelectedAbleToJoinStores: false,
    allSelectedAbleToDisconnectStores: false,
    allSelectedAbleToActivationCancelStores: false
}

export const stores = {
    state: Object.assign({}, initialState),
    mutations: {
        RESET_STATE(state) {
            Object.keys(state).forEach(key => {
                state[key] = initialState[key]
            })
        },
        SET_STORES(state, payload) {
            state.stores = payload
        },
        SET_ABLE_TO_JOIN_STORES(state, payload) {
            state.ableToJoinStores = payload
        },
        SET_ABLE_TO_DISCONNECT_STORES(state, payload) {
            state.ableToDisconnectStores = payload
        },
        SET_ABLE_TO_ACTIVATION_CANCEL_STORES(state, payload) {
            state.ableToActivationCancelStores = payload
        },
        SET_STORES_LOADING_STATUS(state, payload) {
            state.loading = payload
        },
        TOGGLE_ABLE_TO_JOIN_STORE_SELECTED_STATE(state, { id, checked }) {
            const stores = state.ableToJoinStores
            stores.find(store => store.shopId === id).checked = checked
            state.ableToJoinStores = stores
            state.allSelectedAbleToJoinStores = state.ableToJoinStores
                .filter(store => !store.disabled)
                .every(store => store.checked)
        },
        TOGGLE_ABLE_TO_DISCONNECT_STORE_SELECTED_STATE(state, { id, checked }) {
            const stores = state.ableToDisconnectStores
            stores.find(store => store.shopId === id).checked = checked
            state.ableToDisconnectStores = stores
            state.allSelectedAbleToDisconnectStores = state.ableToDisconnectStores
                .filter(store => !store.disabled)
                .every(store => store.checked)
        },
        TOGGLE_ABLE_TO_ACTIVATION_CANCEL_SELECTED_STATE(
            state,
            { id, checked }
        ) {
            const stores = state.ableToActivationCancelStores
            stores.find(store => store.shopId === id).checked = checked
            state.ableToActivationCancelStores = stores
            state.allSelectedAbleToActivationCancelStores = state.ableToActivationCancelStores
                .filter(store => !store.disabled)
                .every(store => store.checked)
        }
    },
    actions: {
        resetUserStoresState({ commit }) {
            commit('RESET_STATE')
        },
        storesFetch({ state, commit, getters }) {
            commit('SET_STORES_LOADING_STATUS', true)
            return this.$api
                .get(`networks/shops/${getters.userId}`)
                .then(response => {
                    const stores = response.data.data.result
                    if (!stores) return
                    stores.forEach(store => {
                        const storeState = store.statusInNetwork
                        store.statusName = getStateName(storeState)
                    })

                    commit('SET_STORES', stores)

                    stores.forEach(store => {
                        store.id = store.shopId
                        store.checked = false
                    })

                    commit(
                        'SET_ABLE_TO_JOIN_STORES',
                        stores
                            .filter(
                                store =>
                                    store.statusInNetwork !== 'request' &&
                                    store.statusInNetwork !== 'accept'
                            )
                            .map(e => Object.assign({}, e))
                    )
                    commit(
                        'SET_ABLE_TO_ACTIVATION_CANCEL_STORES',
                        stores
                            .filter(
                                store => store.statusInNetwork === 'request'
                            )
                            .map(e => Object.assign({}, e))
                    )
                    commit(
                        'SET_ABLE_TO_DISCONNECT_STORES',
                        stores
                            .filter(store => store.statusInNetwork === 'accept')
                            .map(e => Object.assign({}, e))
                    )
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    commit('SET_STORES_LOADING_STATUS', false)
                })
        },
        // able to join service
        toggleAbleToJoinStoreSelectedState({ commit }, { id, checked }) {
            commit('TOGGLE_ABLE_TO_JOIN_STORE_SELECTED_STATE', {
                id: id,
                checked: checked
            })
        },
        selectAllAbleToJoinStores({ commit, getters }) {
            getters.getAbleToJoinStores.forEach(store => {
                if (!store.disabled) {
                    commit('TOGGLE_ABLE_TO_JOIN_STORE_SELECTED_STATE', {
                        id: store.id,
                        checked: true
                    })
                }
            })
        },
        unselectAllAbleToJoinStores({ commit, getters }) {
            getters.getAbleToJoinStores.forEach(store => {
                if (!store.disabled) {
                    commit('TOGGLE_ABLE_TO_JOIN_STORE_SELECTED_STATE', {
                        id: store.id,
                        checked: false
                    })
                }
            })
        },
        // able to disconnect service
        toggleAbleToDisconnectStoreSelectedState({ commit }, { id, checked }) {
            commit('TOGGLE_ABLE_TO_DISCONNECT_STORE_SELECTED_STATE', {
                id: id,
                checked: checked
            })
        },
        selectAllAbleToDisconnectStores({ commit, getters }) {
            getters.getAbleToDisconnectStores.forEach(store => {
                commit('TOGGLE_ABLE_TO_DISCONNECT_STORE_SELECTED_STATE', {
                    id: store.id,
                    checked: true
                })
            })
        },
        unselectAllAbleToDisconnectStores({ commit, getters }) {
            getters.getAbleToDisconnectStores.forEach(store => {
                commit('TOGGLE_ABLE_TO_DISCONNECT_STORE_SELECTED_STATE', {
                    id: store.id,
                    checked: false
                })
            })
        },

        // able to activation cancel service
        toggleAbleToActivationCancelStoreSelectedState(
            { commit },
            { id, checked }
        ) {
            commit('TOGGLE_ABLE_TO_ACTIVATION_CANCEL_SELECTED_STATE', {
                id: id,
                checked: checked
            })
        },
        selectAllAbleToActivationCancelStores({ commit, getters }) {
            getters.getAbleToActivationCancelStores.forEach(store => {
                commit('TOGGLE_ABLE_TO_ACTIVATION_CANCEL_SELECTED_STATE', {
                    id: store.id,
                    checked: true
                })
            })
        },
        unselectAllAbleToActivationCancelStores({ commit, getters }) {
            getters.getAbleToActivationCancelStores.forEach(store => {
                commit('TOGGLE_ABLE_TO_ACTIVATION_CANCEL_SELECTED_STATE', {
                    id: store.id,
                    checked: false
                })
            })
        },
        // forms service
        async cancelOrDisconnectStores({ getters }, stores) {
            const storesSetWithUniqueNetworkId = {}
            stores.forEach((store, storeIdx) => {
                const storeNetworkId = store.networkId
                if (
                    storesSetWithUniqueNetworkId[storeNetworkId] === undefined
                ) {
                    storesSetWithUniqueNetworkId[storeNetworkId] = [store]
                } else {
                    storesSetWithUniqueNetworkId[storeNetworkId].push(store)
                }
            })

            const dataToRequests = Object.entries(
                storesSetWithUniqueNetworkId
            ).map(entry => {
                return {
                    networkId: entry[0],
                    stores: entry[1]
                }
            })

            const userEmail = getters.getUser.email

            const requestsSet = dataToRequests.map(data => {
                return this.$api.delete(
                    `networks/${data.networkId}/shops/${data.stores
                        .map(store => store.shopId)
                        .join(',')}/email/${userEmail}`
                )
            })

            const responses = await Promise.allSettled(requestsSet)

            if (
                responses
                    .map(response => response.status)
                    .every(status => status === 'rejected') ||
                responses
                    .map(response => response.value)
                    .every(
                        value =>
                            value.status !== 200 || !value.data.data.success
                    )
            ) {
                throw new Error('allRejected')
            } else if (
                responses
                    .map(response => response.status)
                    .some(status => status === 'rejected') ||
                responses
                    .map(response => response.value)
                    .some(
                        value =>
                            value.status !== 200 || !value.data.data.success
                    )
            ) {
                throw new Error('someRejected')
            }

            return responses
        },
        addStoresToNetwork({ getters }, { networkId, pin }) {
            const stores = getters.getAbleToJoinStores.filter(
                store => store.checked
            )
            const shopIds = stores.map(store => store.shopId).join(',')
            const email = getters.getUser.email

            return this.$api.post(`networks/${networkId}/shops/${shopIds}`, {
                pin,
                email
            })
        }
    },
    getters: {
        getAbleToJoinStores: state => {
            if (state.ableToJoinStores) {
                return state.ableToJoinStores
            }
        },
        getAbleToDisconnectStores: state => {
            if (state.ableToDisconnectStores) {
                return state.ableToDisconnectStores
            }
        },
        getAbleToActivationCancelStores: state => {
            if (state.ableToActivationCancelStores) {
                return state.ableToActivationCancelStores
            }
        },
        getStoresLoadingState: state => {
            return state.loading
        },
        areAllAbleToJoinStoresSelected: state => {
            return state.allSelectedAbleToJoinStores
        },
        areAllAbleToDisconnectStoresSelected: state => {
            return state.allSelectedAbleToDisconnectStores
        },
        areAllAbleToActivationCancelStoresSelected: state => {
            return state.allSelectedAbleToActivationCancelStores
        }
    }
}
